import { Wrapper, SocialMediaContainer, StyledSocialMediaLink } from './CommunityBar.styles';
import Container from '@components/common/Container';

interface CommunityBarProps {
  mode?: 'filled';
}

export default function CommunityBar({ mode }: CommunityBarProps) {
  return (
    <Container>
      <Wrapper>
        <h4>Join our community</h4>
        <SocialMediaContainer>
          <StyledSocialMediaLink type="discord" />
          <StyledSocialMediaLink type="twitter" />
          <StyledSocialMediaLink type="medium" />
        </SocialMediaContainer>
      </Wrapper>
    </Container>
  );
}
